"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const xstate_1 = require("xstate");
const react_2 = require("@xstate/react");
const prop_types_1 = require("prop-types");
const xstate_2 = require("../../lib/constants/xstate");
const utils_1 = require("../../lib/utils");
const styles_1 = require("./styles");
const Shimmer_1 = __importDefault(require("../../../components/Loading/Provider/Shimmer"));
const ErrorPage_1 = require("../ErrorPage");
const SwitchByState_1 = __importDefault(require("./SwitchByState"));
const CancelAppointmentLayout_1 = __importDefault(require("../Layout/CancelAppointmentLayout"));
function AppointmentCancel({ service }) {
    const [currentState] = (0, react_2.useService)(service);
    const { matches } = currentState;
    if ((0, utils_1.pendingStateMatchHelper)(currentState))
        return react_1.default.createElement(Shimmer_1.default, null);
    // Previously, this condition checked if the current state matched the "error" substate using the subStateMatchHelper utility.
    //  We are keeping this for now to ensure that the sub error 404 page is displayed correctly.
    if ((0, utils_1.subStateMatchHelper)(xstate_2.states.error, currentState)) {
        return (react_1.default.createElement(styles_1.Container, null,
            react_1.default.createElement(ErrorPage_1.ErrorPage, null)));
    }
    const shouldRenderSearchProviderButton = matches(xstate_2.states.canceledPreviously);
    return (react_1.default.createElement(CancelAppointmentLayout_1.default, { service: service, shouldRenderSearchProviderButton: shouldRenderSearchProviderButton, renderChildren: (headerHeight, bodyIsAnimating) => {
            return (react_1.default.createElement(SwitchByState_1.default, { service: service, matches: matches, context: currentState.context, headerHeight: headerHeight, bodyIsAnimating: bodyIsAnimating }));
        } }));
}
exports.default = AppointmentCancel;
AppointmentCancel.propTypes = {
    /**
     * Callback that takes a providerId and returns a URL to be used as a hyperlink to reschedule with the appointment provider
     * @callback createRescheduleLink
     * @param {number} providerId
     */
    createRescheduleLink: prop_types_1.func.isRequired,
    /**
     * The interpreted appointmentCancelMachine that will handle the logic for this component
     */
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired
};
AppointmentCancel.defaultProps = {};
//# sourceMappingURL=AppointmentCancel.js.map